import statement from '../../api/statement'

const state = {
  messages: [],
  upStreamList: [],
  total: 0,
  upStreamTotal: 0,
  sendTotal: 0,
  loading: true,
  dateList: [],
  successList: [],
  totalList: [],
  dataReview: [],
  dataReviewTotal: {},
  failureAnalysis: [],
  failureLegend: [],
  failureReasonList: [],
  defeatCount: [],
  pnList: [],
  pnchartDate: [],
  pnchartData: [],
  errorCode: '',
  tasksData: [],
  cmppAccountList: []
};

const actions = {
  // 获取超级短信发送清单
  async getMmsStatement ({ commit }, payload) {
    const response = await statement.getMmsStatement(payload);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_MESSAGES', {
        messages: data.messages,
        total: data.total
      });
    }
  },
  // 获取短信发送清单
  async getStatement ({ commit }, payload) {
    const response = await statement.getStatement(payload);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_MESSAGES', {
        messages: data.messages,
        total: data.total
      });
    }
  },
  // 获取国际短信发送清单
  async getGlobalStatement ({ commit }, payload) {
    const response = await statement.getGlobalStatement(payload);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_MESSAGES', {
        messages: data.messages,
        total: data.total
      });
    }
  },
  // 获取cmpp账号列表
  async getCmppAccounts ({ commit }, payload) {
    const response = await statement.getCmppAccounts(payload);
    if (response.status === 200) {
      const { data } = response;
      let list = []
      if (data.cmpp_accounts.length) {
        data.cmpp_accounts.forEach(item => {
          const obj = {}
          obj.label = item.sp_id
          obj.value = item.id
          list.push(obj)
        })
      }
      commit('UPDATE_CMPP', {
        cmppAccountList: list
      })
    }
  },
  async getUpStreamStatement ({ commit }, payload) {
    const response = await statement.getUpStreamStatement(payload);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_UPSTREAM', {
        upStreamList: data.mobile_originals,
        total: data.pagination.total
      })
    }
  },
  async getDataReview ({ commit }, payload) {
    const response = await statement.getDataReview(payload);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_DATAREVIEW', {
        dataReview: data.data
      })
    }
  },
  async getFailureAnalysis ({ commit }, payload) {
    function compare (p) { // 这是比较函数
      return function (m, n) {
        const a = m[p];
        const b = n[p];
        return b - a; // 升序
      }
    }
    const response = await statement.getFailureAnalysis(payload);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_FAILUREANALYSIS', {
        failureAnalysis: data.data.sort(compare('value')),
        defeatCount: data.defeat_count
      })
    }
  },
  async updateStatementLoadingStatus ({ commit }, { loading }) {
    commit('UPDATE_STATEMENT_LOADING', {
      loading: loading
    });
  },
  async getPn ({ commit }, payload) {
    const response = await statement.getPn(payload);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_PN', {
        pnList: data.pn_detection_statistics
      })
    }
  },
  async getError ({ commit }, payload) {
    const response = await statement.getError(payload);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_ERROR', {
        errorCode: data.value
      })
    }
  },
  async getTasks ({ commit }, payload) {
    const response = await statement.getTasks(payload);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_TASKS', {
        tasksData: data.tasks,
        total: data.pagination.total
      })
    }
  }
};

const mutations = {
  'UPDATE_MESSAGES': (state, payload) => {
    state.messages = []
    state.messages = payload.messages;
    state.total = payload.total;
    state.loading = false;
  },
  'UPDATE_CMPP': (state, payload) => {
    state.cmppAccountList = payload.cmppAccountList
  },
  'UPDATE_UPSTREAM': (state, payload) => {
    state.loading = false;
    state.upStreamTotal = payload.total;
    state.upStreamList = payload.upStreamList || [];
  },
  'UPDATE_DATAREVIEW': (state, payload) => {
    state.loading = false;
    state.dataReviewTotal = {
      total: 0,
      success_quantity: 0,
      defeat_quantity: 0,
      unknown_quantity: 0
    }
    state.dataReview = payload.dataReview;
    state.dateList = [];
    state.successList = [];
    state.totalList = [];
    state.dataReview.forEach(item => {
      state.dateList.push(item.date)
      state.successList.push(item.success_quantity)
      state.totalList.push(item.total)
      state.dataReviewTotal.total += item.total
      state.dataReviewTotal.success_quantity += item.success_quantity
      state.dataReviewTotal.defeat_quantity += item.defeat_quantity
      state.dataReviewTotal.unknown_quantity += item.unknown_quantity
    });
  },
  'UPDATE_FAILUREANALYSIS': (state, payload) => {
    state.loading = false;
    state.failureAnalysis = payload.failureAnalysis;
    state.defeatCount = payload.defeatCount
    state.failureLegend = [];
    state.failureReasonList = [];
    state.failureAnalysis.forEach(item => {
      let obj = {}
      obj.name = item.error_type
      obj.value = item.value
      state.failureReasonList.push(obj)
      state.failureLegend.push(item.error_type)
    });
  },
  'UPDATE_STATEMENT_LOADING': (state, { loading }) => {
    state.loading = loading;
  },
  'UPDATE_PN': (state, payload) => {
    state.loading = false;
    state.pnList = payload.pnList;
    state.pnchartDate = [];
    state.pnchartData = [];
    state.pnList.forEach(item => {
      item.total = 0
      Object.values(item.carrier).forEach(i => {
        item.total += i
      })
      state.pnchartData.push(item.total)
      state.pnchartDate.push(item.date)
    })
  },
  'UPDATE_ERROR': (state, payload) => {
    state.errorCode = payload.errorCode
  },
  'UPDATE_TASKS': (state, payload) => {
    state.tasksData = payload.tasksData
    state.sendTotal = payload.total
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/statement.js